import styled from '@emotion/styled';
import Logo from '~/icons/logo.svg';
import { mq } from '~/lib';
import { breakpointsRaw } from '~/theme/breakpoints';
import Button from '~/shared/components/Button';
import { Grid } from '~/shared/components/Grid/Grid';

export const StyledCreateAccountLabel = styled.div(({ theme }) => ({
    fontSize: theme.fontSizes['2xs'],
    span: {
        color: theme.colors.orangeMedium,
    },
}));
export const StyledInfoContainer = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    background: theme.colors.grey10,
    padding: '20px',
    span: {
        fontSize: theme.fontSizes.xs,
        color: theme.colors.orangeMedium,
    },
}));

export const StyledLogoWrapper = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    span: {
        color: theme.colors.orangeMedium,
        fontSize: theme.fontSizes.xs,
        marginLeft: '2px',
        textTransform: 'uppercase',
    },
}));
export const StyledLogo = styled(Logo)({
    height: '14px',
    width: '80px',
    margin: 0,
});

export const StyledButton = styled(Button)(({ theme }) => ({
    width: '100%',
    marginTop: theme.space['3'],
    [mq(breakpointsRaw.md)]: {
        display: 'none',
    },
}));

export const StyledAside = styled.aside({
    [mq(0, breakpointsRaw.sm)]: {
        display: 'none',
    },
});

export const StyledGridWrapper = styled(Grid)(({ theme }) => ({
    [mq(0, breakpointsRaw.md)]: {
        gridTemplateColumns: '1fr',
        rowGap: theme.space[3],
        gridAutoFlow: 'row',
    },
}));

export const StyledGrid = styled(Grid)(() => ({
    width: '100%',
    gridAutoFlow: 'row',
    gridTemplateColumns: 'auto',
    [mq(breakpointsRaw.md)]: {
        gridAutoFlow: 'column',
    },
}));

export const StyledTable = styled.div(() => ({
    display: 'inline',
    tableLayout: 'auto',
}));
export const StyledTableRow = styled.div(() => ({
    display: 'table-row',
}));
export const StyledTableCell = styled.div(() => ({
    display: 'table-cell',
    verticalAlign: 'middle',
}));
export const StyledTableCellRightSpace = styled.div(() => ({
    display: 'table-cell',
    verticalAlign: 'middle',
    paddingRight: '30px',
}));
